import map from 'lodash/map'
import type { ShortcutConfig } from '@ztechapps/webui.util'
import { BlogStatus } from '@ztechapps/blog.common'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'
import { DataTool, GridListToggle } from '@ztechapps/webui.data-tools'
import { useKeyboardShortcut } from '@ztechapps/webui.util'
import { AddForm } from './addNew/AddForm'
import { useBlogListContext } from './Context'

const Statuses = map(BlogStatus, (e) => {
  return e.value
})

const fields = [
  { name: 'title', displayName: 'Title' },
  { name: 'slug', displayName: 'Slug' },
  { name: 'summary', displayName: 'Summary' },
  {
    name: 'status',
    displayName: 'Status',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.select,
    fieldSettings: {
      listValues: Statuses,
    },
  },
  { name: 'updatedAt', displayName: 'Date Updated', excludeOnSearch: true, type: ListFieldTypeEnum.dateTimeZone },
  { name: 'remarks', displayName: 'Remarks' },
  { name: 'tags', displayName: 'Tags' },
  { name: '_id', displayName: 'Id', excludeOnSort: true },
]

export type ToolboxProps = {
  refreshShortcut: ShortcutConfig
}

export const Toolbox = ({ refreshShortcut }: ToolboxProps) => {
  const context = useBlogListContext()

  useKeyboardShortcut({ ...refreshShortcut, action: () => context.refetch?.() })

  return (
    <DataTool
      components={{
        add: AddForm,
        other: GridListToggle,
      }}
      onAdd={async () => {
        // Handled by AddForm component
      }}
      {...{
        searchPlaceHolder: 'Search Blogs',
        fields,
        ...context,
      }}
    />
  )
}
